import(/* webpackMode: "eager" */ "/vercel/path0/src/app/adoption-inquiry/page.tsx");
